import * as SDK from '@siloreal:shared:sdk';
type ValidationFn = SDK.validator.form.ValidationFn;
type AdditionalValidationFn = SDK.validator.form.AdditionalValidationFn;
type PhoneValidationFn = ValidationFn & Pick<AdditionalValidationFn, 'blur' | 'change'>;

import * as v from 'valibot';
import { toValidationResult } from './utils';

const DEFAULT_MESSAGES = {
  type: 'El teléfono debe ser texto',
  required: 'El teléfono es requerido',
  number: 'El teléfono debe contener solo números',
  length: 'El teléfono debe tener entre 7 y 15 dígitos',
};

const PhoneSchema = v.pipe(
  v.string(DEFAULT_MESSAGES.type),
  v.nonEmpty(DEFAULT_MESSAGES.required),
  v.digits(DEFAULT_MESSAGES.number),
  v.minLength(7, DEFAULT_MESSAGES.length),
  v.maxLength(15, DEFAULT_MESSAGES.length)
);
const InvariantSchema = v.pipe(
  v.string(DEFAULT_MESSAGES.type),
  v.digits(DEFAULT_MESSAGES.number),
  v.maxLength(15, DEFAULT_MESSAGES.length)
);
const schema = {
  required: PhoneSchema,
  optional: v.union([v.literal(''), PhoneSchema]),
  change: InvariantSchema,
};

export const phone: PhoneValidationFn = (value, options = {}) =>
  toValidationResult(v.safeParse(options.required ?? false ? schema.required : schema.optional, value));
phone.blur = (value) => toValidationResult(v.safeParse(schema.optional, value));
phone.change = (value) => toValidationResult(v.safeParse(schema.change, value));
